import { render, staticRenderFns } from "./UserChoose.vue?vue&type=template&id=f1c82b9a&scoped=true"
import script from "./UserChoose.vue?vue&type=script&lang=js"
export * from "./UserChoose.vue?vue&type=script&lang=js"
import style0 from "./UserChoose.vue?vue&type=style&index=0&id=f1c82b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c82b9a",
  null
  
)

export default component.exports